import { render } from "./SettlementsPage.vue?vue&type=template&id=e3b75006&scoped=true"
import script from "./SettlementsPage.vue?vue&type=script&lang=js"
export * from "./SettlementsPage.vue?vue&type=script&lang=js"

import "./SettlementsPage.vue?vue&type=style&index=0&id=e3b75006&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3b75006"]])

export default __exports__